import axios from 'axios';

/**
 * Abstraction layer for the HTTP request api.
 * Heavily based on {@link https://gist.github.com/oleksmarkh/37c88570e0580ee47773eebbb0866c65/}.
 *
 * Example:
 * import { get, post, put, destroy } from './http';
 * const { data } = get('/thing', {}, {});
 */

/**
 * @see {@link https://github.com/mzabriskie/axios#axios-api}
 *
 * @param {string} method
 * @param {string} url
 * @param {object} config
 * @param {object} options
 */
function request(
  method,
  baseURL = '/',
  url,
  config = {},
  options = {},
) {
  const {
    params,
    data,
    headers,
    maxContentLength,
    responseType = 'json',
  } = config;

  // non-axios specific params
  const { suppressAuth } = options;

  return new Promise((resolve, reject) => {
    axios({
      method,
      baseURL,
      url,
      params,
      data,
      headers: suppressAuth ? headers : { ...headers },
      maxContentLength,
      responseType,
    })
      .then(response => {
        resolve({ ...response });
      })
      .catch(reject);
  });
}

/**
 * @export
 * @param {string} url
 * @param {object} config
 * @param {object} options
 * @returns {Promise}
 */
export function get(baseURL, url, config, options) {
  return request('GET', baseURL, url, config, options);
}

/**
 * @export
 * @param {string} url
 * @param {object} config
 * @param {object} options
 * @returns {Promise}
 */
export function post(baseURL, url, config, options) {
  return request('POST', baseURL, url, config, options);
}
